import { Link } from 'react-router-dom';
import Header from '../../components/header.components';
import { Box, Grid, Divider, Typography } from '@mui/material';
import Sidemenu from '../../components/auth/user/side-menu.component';
import SettingsForm from '../../components/auth/user/settings-form.component';

export const Settings = () => {
    return (
        <Header>
            <Box sx={{ background: "white", pt: 10 }}>
                <Grid container>
                    <Grid item md={1} xs={false} />

                    <Grid item xs={12} md={10}>

                        <Typography id="back-to-top-anchor" className='breadcrumb-menu-center' variant='h4' gutterBottom>Edit profile</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Link style={{ cursor: 'pointer', color: 'gray', textDecoration: 'none' }} to={'/'}>
                                Home
                            </Link>

                            <Typography color="text.primary"> &nbsp; / &nbsp; Edit profile</Typography>
                        </Box>

                        <Divider sx={{ mt: 1, mb: 4, }} />

                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item lg={2} md={3} sm={4} xs={false} sx={{ display: { xs: 'none', md: 'block' } }}>
                                <Sidemenu />
                            </Grid>

                            <Grid item xs={12} sm={10}>
                                <SettingsForm />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={1} xs={false} />
                </Grid>
            </Box>
        </Header >
    )
}
